import { render, staticRenderFns } from "./CanalCobroCrud.vue?vue&type=template&id=253c8282"
import script from "./CanalCobroCrud.vue?vue&type=script&lang=js"
export * from "./CanalCobroCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports